import { httpService } from '.';
export const getAcceptedAgeRangesRequest = async () => {
    const response = await httpService.get('/api/acceptedAgeRanges');
    const { acceptedAgeRanges } = response.data.data;
    return acceptedAgeRanges;
};
